<template>
    <a href="javascript:void(0);" @click="scrollUp()" :class="['scrollup', isVisible ? 'visible' : '',]" ></a>
</template>

<script>
export default {
    name: 'ScrollupBtn',
    data : () => ({
        isVisible : ($(window).scrollTop() > 700),
    }),
    mounted(){
        $(window).scroll((e) => {
            this.isVisible = ($(window).scrollTop() > 700);
        });
    },
    methods : {
        scrollUp(){
            $('html,body').animate(
                {
                    scrollTop : 0,
                },
                700
            );
        },
    },
}
</script>
